import { LoadingOutlined } from '@ant-design/icons';
import { Flex, Form, Typography } from 'antd';
import { t } from 'i18next';

import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';

import { EmailSettings, useGetEmailSetingsQuery, useUpdateEmailSetingsMutation } from 'features/config';

type FormData = EmailSettings;

export const Email = () => {
  const [form] = Form.useForm<FormData>();
  const { data, isLoading } = useGetEmailSetingsQuery();
  const [update, { isSuccess, isError, isLoading: isUpdateLoading, error }] = useUpdateEmailSetingsMutation();

  const onFinish = (values: FormData) => {
    update(values);
  };

  useNotification({
    isSuccess,
    isError,
    error
  });

  if (isLoading) {
    return <LoadingOutlined />;
  }

  return (
    <div>
      <Flex align="center" justify="space-between">
        <Typography.Title level={2}>{t('pages.email-settings')}</Typography.Title>
      </Flex>

      <Form
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        name="basic"
        initialValues={data}
        style={{ maxWidth: '600px' }}
      >
        <InputStr type='login' />
        <InputStr type='address' />
        <InputStr type='password' />
        <InputStr type='port' innputNumberProps={{ max: 9999 }} />
        <InputStr type='emailProxyUrl' />
        <SubmiteButton isLoading={isUpdateLoading} />
      </Form>
    </div >
  );
};

